import React, { useState } from 'react';
import { ContentBox } from '../../libs/theme';
import { Grid, Typography, Box, useMediaQuery, Tabs, Tab } from '@mui/material';
import REST from '../../libs/API';
import { useEffect } from 'react';
import { getText } from '../../libs/utils';
import { useTheme, styled } from "@mui/material/styles";
import { useParams } from 'react-router-dom';
//import { useNavigate } from 'react-router-dom';

const MyGrid = styled(Grid)(({ theme }) => ({
  margin: '0 0 36px',
  [theme.breakpoints.only('sm')]: {
    margin: '8px 0 32px'
  },
  [theme.breakpoints.only('xs')]: {
    margin: '-5px 0 32px'
  },
  "h3": {
    [theme.breakpoints.down('md')]: {
      margin: '0 0 26px'
    },
  }
}))

const Rules = () => {
  //const navigate = useNavigate();
  const theme = useTheme();
  let params = useParams();
  let isSM = useMediaQuery(theme.breakpoints.down('md'));
  const [page, setPage] = useState(params.page || "rules");
  const [text, setText] = useState({});
  const [tab, setTab] = useState(params.page || "rules");
  const [loading, setLoading] = useState(true);

  const tabs = {
    rules: { title: getText('footerRules') },
    dataPerform: { title: getText('footerDataPerf') },
    cookie: { title: 'CookieS' },
    aml: { title: getText('amlPage') },
  }

  const getPageContent = (key) => {
    setLoading(true);
    REST.getViewPage(key).then((data) => {
      if (data.success === true) {
        setText(data.pageParams);
      }
      setLoading(false);
    })
  }

  const handleChange = (event, newValue) => {
    setTab(newValue);
    setPage(newValue)
  };

  useEffect(() => {
    getPageContent(page);
  }, [page])

  return (
    <>
      <MyGrid container alignItems="center">
        <Grid item md={4} sm={12} xs={12}>
          <Typography variant='h3' sx={{ marginBottom: 0 }}>{getText('linkRules')}</Typography>
        </Grid>
        <Grid item md={8} sm={12} xs={12}>
          <Box sx={{ display: 'flex', justifyContent: isSM ? 'start' : 'end' }}>
            <Tabs
              value={tab}
              onChange={handleChange}
              variant="scrollable"
              sx={{
                justifyContent: 'flex-end'
              }}
              TabIndicatorProps={{
                hidden: true
              }}
            >
              {Object.keys(tabs).map((tabKey) => (
                <Tab
                  key={tabKey}
                  value={tabKey}
                  label={tabs[tabKey].title}
                />
              ))}
            </Tabs>
          </Box>
        </Grid>
      </MyGrid>
      <ContentBox sx={{ minHeight: 486 }}>
        {loading ? <span className="dot-spin centered"></span>
          : <>
            <Typography variant="h4" fontWeight={600}>{text.title ? text.title : tabs[page].title}</Typography>
            <Box dangerouslySetInnerHTML={{ __html: text.content }}></Box>
          </>}
      </ContentBox>
    </>
  )
}

export default Rules